export var avatarGroupTheme = {
  baseStyle: _ref => {
    var {
      isLast
    } = _ref;
    return {
      container: {
        display: 'flex',
        position: 'relative'
      },
      avatar: {
        display: 'inline-flex',
        marginRight: isLast ? 'none' : '-4px',
        borderRadius: 'full',
        border: 'basic.light',
        cursor: 'pointer'
      },
      description: {
        display: 'inline-flex',
        marginLeft: 'xxxs',
        alignItems: 'center',
        color: 'neutral.darkest',
        textStyle: 'body4Semi',
        cursor: 'pointer'
      }
    };
  }
};
//# sourceMappingURL=AvatarGroup.theme.js.map